import { authenticator } from "../Authentication/auth-funcs";
import logger from "../utils/logger";

// Content-Type used by several legacy GET thunks. Kept as a constant so call
// sites preserve the exact header they were sending before this helper existed.
export const FORM_URLENCODED_CONTENT_TYPE =
  "application/x-www-form-urlencoded; charset=UTF-8";

// Builds the standard auth headers from an already-fetched session.
// `contentType` and `includeIdentityId` exist so each caller can keep the
// exact headers it sent before deduplication (the Redux thunks historically
// omitted X-Cognito-Identity-Id).
export function buildAuthHeaders(
  session,
  { contentType = "application/json", includeIdentityId = true } = {}
) {
  const headers = {
    Accept: "application/json",
    "Content-Type": contentType,
    Authorization: `Bearer ${session.tokens.idToken}`,
  };
  if (includeIdentityId) {
    headers["X-Cognito-Identity-Id"] = session.identityId;
  }
  return headers;
}

// Fetches the current Cognito session and builds auth headers from it.
export async function getAuthHeaders(options = {}) {
  try {
    const session = await authenticator.getUserSessionDetails();

    if (!session?.tokens?.idToken) {
      throw new Error("No valid session found");
    }

    const { includeIdentityId = true } = options;
    if (includeIdentityId && !session.identityId) {
      throw new Error("No identity ID found in session");
    }

    return buildAuthHeaders(session, options);
  } catch (error) {
    logger.error("Error getting auth headers:", error);
    throw error;
  }
}
